import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    height: 100vh;
    max-width: 400px;
    margin: 0 auto;
    @media screen and (max-width: 769px) {
        max-width: 700px;
        margin: 0;
    }
`;

export const HeaderWrapper = styled.div`
    padding: 20px;
    padding-bottom: 0px;
`;

export const CustomPlanDetailsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px;
    padding-bottom: 35px;
    background: linear-gradient(161.3deg, #fff7e5 -2.04%, #fbe9f6 102.81%);
`;

export const HeaderTitle = styled.div`
    display: flex;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    color: #040222;
    margin: 5px 0;
`;

export const PlanDetailsWrapper = styled.div`
    display: flex;
    padding: 12px;
    flex-direction: column;
    background: #ffffff;
    border-radius: 12px;
    margin-top: 14px;
`;

export const RowWrapper = styled.div`
    display: flex;
    margin-top: 10px;
`;

export const LabelText = styled.div`
    display: flex;
    flex: 1;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #5b5675;
`;

export const ValueText = styled.div`
    display: flex;
    flex: 1;
    justify-content: flex-end;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #040222;
    text-align: end;
`;

export const Hr = styled.div`
    width: 100%;
    height: 0px;
    opacity: 0.1;
    border: 1px solid #040222;
    margin-top: 10px;
`;

export const CustomerDetailsFormWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px;
    background: #ffffff;
    box-shadow: 0px -6px 12px -2px rgba(54, 53, 76, 0.08);
    border-radius: 24px 24px 0px 0px;
    margin-top: -15px;
`;

export const FormTitle = styled.div`
    display: flex;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    color: #040222;
`;

export const InputWrapper = styled.div`
    display: flex;
    margin-top: 24px;
`;

export const TncWrapper = styled.div`
    display: flex;
    margin-top: 15px;
`;

export const CheckboxFlex = styled.div`
    display: flex;
    align-items: center;
    margin-top: 5px;
`;

export const TncText = styled.div`
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #040222;
    margin-left: 10px;
`;

export const PriceDetailsFlex = styled.div`
    display: flex;
    padding: 15px 20px;
`;

export const Price = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    letter-spacing: -0.8px;
    color: #040222;
`;

export const Tax = styled.div`
    display: flex;
    flex: 3;
    align-items: center;
    margin-left: 10px;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #5b5675;
`;

export const Hr1 = styled.div`
    width: 100%;
    height: 0px;
    border: 1px solid #e7e7f0;
`;

export const PayNowButton = styled.div`
    display: flex;
    justify-content: flex-end;
`;
